import React from 'react';
import DesignOptionFilterForm from '../DesignOptionFilterForm';
import enhance from './enhance.js';

export const InteriorOptionFilters = ({
  options,
  interiorFormPlaceHolder,
  setActiveFilters,
  activeFilters,
  clearFilter,
}) => {
  return (
    <DesignOptionFilterForm
      options={options}
      placeHolder={interiorFormPlaceHolder}
      setActiveFilters={setActiveFilters}
      filterName="interiorOption"
      activeFilters={activeFilters}
      clearFilter={clearFilter}
    />
  );
};

export default enhance(InteriorOptionFilters);
